import React, { useState } from 'react';
import { useFirebase } from "../context/firebase.context.jsx";
import Notification from "./Notifications.components.jsx"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faShare } from '@fortawesome/free-solid-svg-icons';
import '../components/CSS/Form.css';

const Form = () => {
    const firebase = useFirebase();
    const [name, setName] = useState('');
    const [classs, setClasss] = useState('');
    const [school, setSchool] = useState('');
    const [rank, setRank] = useState('');
    const [studID, setStudID] = useState('');
    const [destPic, setDestPic] = useState();
    const [showNotification, setShowNotification] = useState(false);
    const [notificationMessage, setNotificationMessage] = useState("");

    const handleSubmit = async (e) => {
        e.preventDefault();
        
        try {
            await firebase.setArticles(name, classs, school, rank, studID, destPic);
            setNotificationMessage("Data Added");
            setShowNotification(true);
            
            setTimeout(() => {
                setShowNotification(false);
            }, 3000);
        } catch (error) {
            setNotificationMessage("Sorry, Try Again");
            setShowNotification(true);
        }
    };

    
    return (
        <div className='container my-5'>
            <Notification variant={"success"} show={showNotification} message={notificationMessage} onClose={() => setShowNotification(false)} />
            <form className='bg-light p-4 rounded shadow' onSubmit={handleSubmit}>
                <h2 className='fw-bolder text-center mb-4'>
                    Add Students
                </h2>

                <div className="form-group">
                    <label htmlFor='name'>Name</label>
                    <input
                        type='text'
                        id='name'
                        className='form-control'
                        value={name}
                        onChange={(e) => setName(e.target.value)}
                        placeholder='Enter your name'
                        required
                    />
                </div>

                <div className="form-group">
                    <label htmlFor='class'>Class</label>
                    <input
                        type='number'
                        id='class'
                        className='form-control'
                        value={classs}
                        onChange={(e) => setClasss(e.target.value)}
                        placeholder='Enter your class'
                        required
                    />
                </div>

                <div className="form-group">
                    <label htmlFor='school'>School</label>
                    <input
                        type='text'
                        id='school'
                        className='form-control'
                        value={school}
                        onChange={(e) => setSchool(e.target.value)}
                        placeholder='Enter your school'
                        required
                    />
                </div>

                <div className="form-group">
                    <label htmlFor='rank'>Rank</label>
                    <input
                        type='number'
                        id='rank'
                        className='form-control'
                        value={rank}
                        onChange={(e) => setRank(e.target.value)}
                        placeholder='Enter your rank'
                        required
                    />
                </div>

                <div className="form-group">
                    <label htmlFor='studID'>Student ID</label>
                    <input
                        type='number'
                        id='studID'
                        className='form-control'
                        value={studID}
                        onChange={(e) => setStudID(e.target.value)}
                        placeholder='Enter your student ID'
                        required
                    />
                </div>
 
                <div className="form-group">
                    <input
                        type='file'
                        id='file'
                        onChange={(e) => setDestPic(e.target.files[0])}
                        style={{ display: 'none' }}
                    />
                    <label htmlFor='file' className='btn btn-secondary custom-file-upload w-100'>
                        Upload Photos
                    </label>
                    {destPic && <span className='d-block mt-2'>{destPic.name}</span>}
                </div>

                <button type='submit' className="btn btn-primary w-100 mt-3">
                    Submit
                    <FontAwesomeIcon icon={faShare} className="ml-2" />
                </button>
            </form>
        </div>
    );
};

export default Form;
